import React, { useState, useEffect } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { fetchCategoryStock } from '../../data/api';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const ProductCategoryChart = () => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    fetchCategoryStock().then(r => {
      const cats = r.data;
      setChartData({
        labels: cats.map(c => c.cat),
        datasets: [
          {
            label: 'Adequate (≥3 months)',
            data: cats.map(c => parseInt(c.adequate_items) || 0),
            backgroundColor: '#27ae60',
            borderRadius: 4,
            barPercentage: 0.6
          },
          {
            label: 'Low (1-3 months)',
            data: cats.map(c => parseInt(c.low_items) || 0),
            backgroundColor: '#f39c12',
            borderRadius: 4,
            barPercentage: 0.6
          },
          {
            label: 'Critical (<1 month)',
            data: cats.map(c => parseInt(c.critical_items) || 0),
            backgroundColor: '#e74c3c',
            borderRadius: 4,
            barPercentage: 0.6
          }
        ]
      });
    }).catch(console.error);
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'top', align: 'end', labels: { boxWidth: 12, font: { size: 10, weight: '600' } } },
      datalabels: { display: true, color: '#fff', font: { weight: '700', size: 10 }, formatter: v => v > 0 ? v : '' },
      tooltip: {
        callbacks: {
          afterBody: function(context) {
            const idx = context[0].dataIndex;
            return '';
          }
        }
      }
    },
    scales: {
      x: { stacked: true, grid: { display: false }, ticks: { font: { size: 11, weight: '600' } } },
      y: { stacked: true, ticks: { font: { size: 10 }, stepSize: 50 }, grid: { color: '#f8fafc' }, title: { display: true, text: 'No. of SKUs', font: { size: 10 } } }
    }
  };

  return (
    <div className="chart-box">
      <h3>Product Category wise Stock Level (EDL vs SDL)</h3>
      <div style={{ position: 'relative', minHeight: '300px' }}>
        {chartData ? <Bar data={chartData} options={options} /> : <p>Loading...</p>}
      </div>
    </div>
  );
};

export default ProductCategoryChart;
